function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M247.9 100.3c4.8-8.4 7.2-18.4 7.2-29.4 0-34.4-23.6-56.7-60.2-56.7s-60.2 22.2-60.2 56.7c0 34.4 23.6 56.6 60.2 56.7h.1c14.1 0 24.8-3.2 32.6-7.5l31.7 31.7 20-20-31.4-31.5zm-53-1.1c-26.4 0-31.9-15.4-31.9-28.3s5.5-28.3 31.9-28.3 31.9 15.4 31.9 28.3c0 5.9-1.2 14.2-7.1 20.1-5.3 5.4-13.6 8.2-24.8 8.2zM77.1 236.5l-12.5-25.4 71.7-35.4 53.1 26.4 66-35.8 13.6 24.9-79 42.8-53.8-26.7-59.1 29.2zm206.4 18.6v28.4H0V99.2h42.5v28.4H28.3v21.2h14.2V163H28.3v21.3h14.2v14.1H28.3v21.3h14.2v14.2H28.3v21.2h255.2z"
})));